import type { PrecompiledWeek } from "./Entities";

export type ExerciseProgressionSource =
  | {
      kind: "library";
      precompiledProgressionId: string;
      detached?: boolean;
      libraryVersion?: string;
    }
  | { kind: "inline" };

export interface ExerciseProgression {
  weeks: PrecompiledWeek[];
  source: ExerciseProgressionSource;
  currentWeekIndex?: number;
}

export type ExerciseEntry = {
  id?: string;
  type: "catalog" | "custom";
  exerciseId?: number;
  // Muscle group of the exercise. For catalog exercises it mirrors the chosen
  // catalog exercise's muscle group (and drives the catalog option filter);
  // for custom exercises it is the trainer's free pick. Editable in both
  // create/edit and the detail view.
  muscleGroupId?: number;
  customName?: string;
  imageUrl?: string;
  image?: File;
  videoUrl?: string;
  video?: File;

  isSuperSet?: boolean;
  superSetRefExerciseId?: number;
  notes?: string;

  progression?: ExerciseProgression;
};

export type Split = {
  id?: string;
  dayName: string;
  exercises: ExerciseEntry[];
};

export class Programmazione {
  id?: string;
  userId?: number;
  nSplits: number;
  splits: Split[];
  scadenza?: string;
  parentId: number;
  isPublic: boolean;
  name: string;

  constructor(parentId: number) {
    this.parentId = parentId;
    this.nSplits = 0;
    this.splits = [];
    this.name = "";
    this.isPublic = false;
  }
}
